export default __webpack_public_path__ + "images/U1.27b6cba.png";